import { Respondent } from "./respondent";

export class SupplierUrlEncryptionInputData {
  respondent: Respondent = new Respondent();
  url: string = "";
  accountId: number = 0;
  constructor() {}
}
